import * as _ from 'lodash'
import {TagBO} from "./TagBO"
import {WB_TagSourceRow} from '../PA.Core/PAdbSchemaRows'
import { esWB_Tag_Source } from '../PA.Core/PAdbSchema'
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils"

export class TagBOValidations {

    static async BeforeSave(aBO: TagBO): Promise<void> {
        const aTagSourceRow: WB_TagSourceRow = await aBO.dbContext.find(esWB_Tag_Source, aBO.WB_Tag.cif.WB_TAG_SOURCE_ID)

        if(_.isEmpty(aTagSourceRow))
            return

        const checkModelTagType: boolean = (aTagSourceRow?.cif.TAG_SOURCE_ID === 'MODEL OBSERVATION' || aTagSourceRow?.cif.TAG_SOURCE_ID === 'MODEL STATISTICS')

        if (checkModelTagType)
            return
        
        const md = aBO.WB_Tag.cif
        md.MODEL_TAG_TYPE = ''
        md.MODEL_TAG_RESERVED_IND = '0'
    }

    static async Validate(aBO: TagBO): Promise<void> {

        await TagBOValidations.BeforeSave(aBO)

        const aTagSourceRow: WB_TagSourceRow = await aBO.dbContext.find(esWB_Tag_Source, aBO.WB_Tag.cif.WB_TAG_SOURCE_ID)

        if(_.isEmpty(aTagSourceRow))
            return

        const emptyModelTagType: boolean = ((aTagSourceRow?.cif.TAG_SOURCE_ID === 'MODEL OBSERVATION' || aTagSourceRow?.cif.TAG_SOURCE_ID === 'MODEL STATISTICS') && (_.isEmpty(aBO.WB_Tag.cif.MODEL_TAG_TYPE) || _.isNull(aBO.WB_Tag.cif.MODEL_TAG_TYPE)))
        ErrorMessage_restate(aBO.ValidateMessageProvider, emptyModelTagType, "EmptyModelTagType", "Model Tag Type is required for Model Related Tags")
    }
}